module.exports = __webpack_public_path__ + "img/desktop-VTA-agencia.f22f4edb.png";